import { memo, useState } from "react";
import {
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    Table,
    TableBody,
    Chip,
    Typography

} from "@mui/material";
import { CreditCard } from "@mui/icons-material";
import { formatAmount } from "../../../../HelperFunctions/HelperFunctions";
import { useRef } from "react";
import CustomPagination from "../../../../HelperFunctions/CustomPagination";


const ChargeBacksTabTable = ({ rows, tab }) => {

    const reversedColumns = [
        { name: 'Reversal Date', dataKey: 'reversal_date', width: 120 },
        { name: 'Amount', dataKey: 'amount', width: 100 },
        { name: '', dataKey: '', width: 120 },
        { name: 'Case Number', dataKey: 'case_number', width: 150 },
        { name: 'Chargeback Date', dataKey: 'charge_back_date', width: 130 },
        { name: 'Transaction Date', dataKey: 'transaction_date', width: 130 },
        { name: 'Dispute Date', dataKey: 'dispute_date', width: 120 },
        { name: 'Reason', dataKey: 'reason', width: 200 },
        { name: 'Chargeback Amount', dataKey: 'amount', width: 150 }
    ];

    const irreversibleColumns = [
        { name: 'Response Date', dataKey: 'response_date', width: 120 },
        { name: 'Amount', dataKey: 'amount', width: 100 },
        { name: '', dataKey: '', width: 120 },
        { name: 'Reason for Irreversible', dataKey: 'irreversible_reason', width: 200 },
        { name: 'Case Number', dataKey: 'case_number', width: 150 },
        { name: 'Chargeback Date', dataKey: 'charge_back_date', width: 130 },
        { name: 'Transaction Date', dataKey: 'transaction_date', width: 130 },
        { name: 'Dispute Date', dataKey: 'dispute_date', width: 120 },
        { name: 'Reason', dataKey: 'reason', width: 200 },
        { name: 'Chargeback Amount', dataKey: 'amount', width: 150 }
    ];

    const columns = tab === "Irreversible" ? irreversibleColumns : reversedColumns;


      const [page, setPage] = useState(0);
      const [rowsPerPage, setRowsPerPage] = useState(40);
      const totalPages = Math.ceil(rows.length / rowsPerPage);
    
      const paginatedRows = rows.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      );
      const tableContainerRef = useRef(null);
        const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



    const ValueCell = memo(({ value }) => {
        const displayValue = (value !== null && value) ? value : '-';
        return <span title={displayValue}>{displayValue}</span>;
    });

    const IconCell = () => (

        <Chip
            sx={{
                borderRadius: 1,
                backgroundColor: tab === "Reversed" ? "#cbe8c7" : "#fdecd5",
                fontSize: "10px",
                fontWeight: 700,
                color: tab === "Reversed" ? "#0e7634" : "#f59c28",
                px: 1,
                '& .MuiChip-icon': {
                    color: tab === "Reversed" ? "#0e7634" : "#f59c28",
                    fontSize: '20px',
                }
            }}
            icon={< CreditCard />}
            label={tab}
            size='small'

        />
    );

    const RenderChip = ({ value }) => (

        <Chip
            sx={{
                borderRadius: 1,
                backgroundColor: "#f8ced3",
                fontSize: "11px",
                color: "#D9001B",
                px: 1,
                '& .MuiChip-icon': {
                    color: "#D9001B",
                    fontSize: '13px',
                }
            }}
            label={value ? value : '-'}
            size='small'

        />
    );

    return (
        <>

        <TableContainer sx={{ overflow: 'auto', height: "100%"  }}>
            <Table stickyHeader sx={{ width: '100%' }}>
                <TableHead>
                    <TableRow sx={{ backgroundColor: "#d7d7d7" }}>


                        {columns.map((col, idx) => (
                            <TableCell key={idx}
                                style={{
                                    backgroundColor: "#d7d7d7",
                                    // borderRight: "1px solid white",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    fontSize: 13,
                                    maxWidth: col.width

                                }}>
                                <span title={col.name}> {col.name} </span>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {

                        paginatedRows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={columns.length + 4} align="center" sx={{ fontSize: 14, color: '#999' }}>
                                    No data available
                                </TableCell>
                            </TableRow>
                        ) :

                            paginatedRows.map((row, rowIndex) => (
                                <TableRow key={row.schedule_id} hover>

                                    {columns.map((col, idx) => (
                                        <TableCell key={idx}

                                            style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: 12,
                                                fontWeight: 500,
                                                color: "#626262",
                                                // borderRight: "1px solid #f2f2f2",
                                                maxWidth: col.width

                                            }}>
                                            {
                                                col.name == "Chargeback Amount" ?
                                                    <RenderChip value={row[col.dataKey]} />
                                                    :
                                                    col.name === "" ?
                                                        <IconCell />
                                                        :
                                                        col.name === "Amount" ?
                                                            <Typography fontWeight={500} color="black" >$ {formatAmount(row[col.dataKey])}</Typography>
                                                            :

                                                            <ValueCell value={row[col.dataKey]} />
                                            }
                                        </TableCell>
                                    ))}
                                </TableRow>


                            ))}
                </TableBody>
            </Table>
        </TableContainer>
          <CustomPagination
        page={page}
        totalPages={totalPages}
        onPageChange={setPage}
        scrollRef={tableContainerRef}
      />
      </>
    );
};
export default ChargeBacksTabTable;